import React, { useEffect, useState } from 'react';
import { Button, Container, useTheme, useMediaQuery, Box, TextField, IconButton } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloseIcon from '@mui/icons-material/Close';

function UploadImage({ imagesData = [], tittle, onUpload, onImagesSelected, readonly = false, uploadImage = false, sx, showImages = true }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [remoteImages, setRemoteImages] = useState(imagesData);
  const [localImages, setLocalImages] = useState([]);
  const [currentImage, setCurrentImage] = useState(null);
  const [images, setImages] = useState(imagesData);

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const newLocalImages = files.map(file => URL.createObjectURL(file));
    setLocalImages(prev => [...prev, ...newLocalImages]);
    if (files.length > 0) {
      setCurrentImage(URL.createObjectURL(files[0]));
      if (onImagesSelected) {
        onImagesSelected(files);
      }
    } else {
      setCurrentImage(null);
    }
  };

  const handleImageClick = (index, isLocal) => {
    if (isLocal) {
      const updatedLocalImages = localImages.filter((_, i) => i !== index);
      setLocalImages(updatedLocalImages);
      if (updatedLocalImages.length > 0) {
        setCurrentImage(updatedLocalImages[0]);
      } else if (remoteImages.length > 0) {
        setCurrentImage(remoteImages[0]);
      } else {
        setCurrentImage(null);
      }
    } else {
      const updatedRemoteImages = remoteImages.filter((_, i) => i !== index);
      setRemoteImages(updatedRemoteImages);
      if (updatedRemoteImages.length > 0) {
        setCurrentImage(updatedRemoteImages[0]);
      } else if (localImages.length > 0) {
        setCurrentImage(localImages[0]);
      } else {
        setCurrentImage(null);
      }
    }
  };

  const handleUploadImages = () => {
    if (onUpload) {
      onUpload(localImages);
    }
  };

  useEffect(() => {
    if (remoteImages.length > 0) {
      setCurrentImage(remoteImages[0]);
    }
  }, [remoteImages]);  

  return (
    <Container>
      <Box display='flex' flexDirection='column' alignItems='center' sx={sx}>
        {tittle && <h2>{tittle}</h2>}
        <input
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          style={{ display: 'none' }}
          id="image-upload-input"
          multiple
        />
        {(!readonly || uploadImage) && (
          <label htmlFor="image-upload-input" style={{ alignSelf: 'baseline' }}>
            <Button
              variant="text"
              component="span"
              color="primary"
              startIcon={<CloudUploadIcon />}
              sx={{ alignSelf: 'baseline' }}
            >
              Seleccionar Imágenes
            </Button>
          </label>
        )}
        {showImages && currentImage && (
          <img
            src={currentImage}
            alt="Imagen actual"
            style={{ height: '100%', width: '100%', objectFit: 'cover', alignContent: 'center', position: 'relative' }}
          />
        )}
        {showImages && <div>
          {remoteImages.length > 0 && remoteImages.map((image, index) => (
            <div key={`remote-${index}`} style={{ position: 'relative', display: 'inline-block', marginRight: '10px' }}>
              <IconButton
                aria-label="Eliminar imagen"
                style={{ position: 'absolute', top: '5px', right: '5px', zIndex: 1, background: '#ffffff' }}
                onClick={() => handleImageClick(index, false)}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
              <img
                src={image}
                alt={`Imagen remota ${index}`}
                style={{ maxWidth: '100px', cursor: 'pointer' }}
                onClick={() => handleImageClick(index, false)}
              />
            </div>
          ))}
          {localImages.length > 0 && localImages.map((image, index) => (
            <div key={`local-${index}`} style={{ position: 'relative', display: 'inline-block', marginRight: '10px' }}>
              <IconButton
                aria-label="Eliminar imagen"
                style={{ position: 'absolute', top: '5px', right: '5px', zIndex: 1, background: '#ffffff' }}
                onClick={() => handleImageClick(index, true)}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
              <img
                src={image}
                alt={`Imagen local ${index}`}
                style={{ maxWidth: '100px', cursor: 'pointer' }}
                onClick={() => handleImageClick(index, true)}
              />
            </div>
          ))}
        </div>}
        {!readonly && !uploadImage && localImages.length > 0 && (
          <Button
            variant="contained"
            color="primary"
            onClick={handleUploadImages}
          >
            Subir Imágenes
          </Button>
        )}
      </Box>
    </Container>
  );
}

export default UploadImage;
